import { initializeApp } from "firebase/app";
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";

const firebaseProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "lesson-launchpad";

const firebaseConfig = {
  apiKey: "AIzaSyAPd2LMtC7vFFEkWCatphSO2FwD1rEJbmg",
  authDomain: "lesson-launchpad.firebaseapp.com",
  databaseURL: "https://lesson-launchpad-default-rtdb.firebaseio.com",
  projectId: firebaseProjectId,
  storageBucket: `${firebaseProjectId}.appspot.com`,
  messagingSenderId: "403855687421",
  appId: "1:403855687421:web:1904b9fd442d046cde8894",
};

const app = initializeApp(firebaseConfig);

/**
 * Firestore uses IndexedDB persistent local cache (multi-tab) for classroom
 * reliability and faster warm starts. onSnapshot listeners emit cached data
 * first, then server-confirmed updates — server/listener data always wins.
 *
 * Do not call enableIndexedDbPersistence separately; localCache is configured
 * here via initializeFirestore (required before first Firestore use).
 */
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
  experimentalAutoDetectLongPolling: true,
});

const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

const shouldUseFirebaseEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";
const firestoreEmulatorPort = Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8085);

if (shouldUseFirebaseEmulators && firebaseProjectId === "lesson-launchpad") {
  throw new Error(
    "Refusing to use Firebase emulators with the production Firebase project ID. Set REACT_APP_FIREBASE_PROJECT_ID=lesson-launchpad-test."
  );
}

if (shouldUseFirebaseEmulators && !globalThis.__lessonLaunchpadFirebaseEmulatorsConnected) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", firestoreEmulatorPort);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  globalThis.__lessonLaunchpadFirebaseEmulatorsConnected = true;
}

export { auth, db, storage, functions, httpsCallable };
